import type { AppDispatch, RootState } from '../../store';
import { setDrawActive as setEquipmentDrawActive } from '../equipment/equipmentSlice';
import {
  setActiveTool,
  setPlacingStopForVehicle,
  setPointDrawActive,
  setShowSimulationTrackNodes,
  setTrackNodePlacementActive,
} from './uiSlice';

/** Canvas modes that own pointer input and therefore cannot run together. */
export type CanvasTool = 'point-draw' | 'equipment-draw' | 'track-node' | null;

/**
 * Activate one canvas tool and drop every other one, so the toolbox never shows
 * two tools highlighted and the canvas never has to arbitrate between them.
 * Flags are only dispatched when they actually change, since the "off" reducers
 * also discard in-progress geometry (draw points, pending footprints, …).
 */
export const activateCanvasTool =
  (tool: CanvasTool) => (dispatch: AppDispatch, getState: () => RootState) => {
    const state = getState();

    dispatch(setActiveTool('select'));

    const wantPointDraw = tool === 'point-draw';
    if (state.ui.pointDraw.active !== wantPointDraw) {
      dispatch(setPointDrawActive(wantPointDraw));
    }

    const wantEquipmentDraw = tool === 'equipment-draw';
    if (state.equipment.draw.active !== wantEquipmentDraw) {
      dispatch(setEquipmentDrawActive(wantEquipmentDraw));
    }

    const wantTrackNode = tool === 'track-node';
    if (state.ui.trackNodePlacementActive !== wantTrackNode) {
      dispatch(setTrackNodePlacementActive(wantTrackNode));
    }
    if (wantTrackNode) dispatch(setShowSimulationTrackNodes(true));

    if (state.ui.placingStopForVehicle !== null) {
      dispatch(setPlacingStopForVehicle(null));
    }
  };
